<template>
  <div class="GoodsReturnPage" id="GoodsReturnPage" v-if="!showLoad">
    <div class="wrap" :style="{ height: contentHeight + 'px' }">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode != 'add'"
          readonly
          label="归还人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          v-else
          readonly
          label="归还人："
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="backTime"
          input-align="right"
          class="ggInput"
          readonly
          label="归还时间："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.materialName"
          input-align="right"
          class="ggInput"
          readonly
          label="名称："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.materialType"
          input-align="right"
          class="ggInput"
          label="类型："
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.receiveAmount"
          type="digit"
          class="ggInput"
          input-align="right"
          label="领用数量："
          readonly
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.yetReturnNum"
          type="digit"
          class="ggInput"
          input-align="right"
          label="已归还数量："
          readonly
          required
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.returnAmount"
          @input="returnAmountChange"
          type="digit"
          class="ggInput"
          input-align="right"
          label="归还数量："
          :readonly="!editType"
          :required="editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="reason"
          label="归还原因："
          required
          rows="1"
          autosize
          input-align="right"
          type="textarea"
          class="ggInput"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button type="info"   :loading="btnLoading"
        :loading-text="loadingText" @click="checkInput()" class="btn"
        >我要归还</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button type="danger"   :loading="btnLoading"
        :loading-text="loadingText" @click="delApply">删除</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button type="info"   :loading="btnLoading"
        :loading-text="loadingText" @click="checkInput()">保存</van-button>
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny' && mode != 'verify'"
      >
        <van-button type="info"   :loading="btnLoading"
        :loading-text="loadingText" @click="checkInput()">我要归还</van-button>
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button type="info"   :loading="btnLoading"
        :loading-text="loadingText" @click="delApply">撤回修改</van-button>
    </div>
    <!-- 弹出框 -->
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/

import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
import {
  dateFormat,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
} from "@/utils/common";
export default {
  name: "goodsReturn",
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  data() {
    return {
      mode: "add",
      backId: "", //归还Id
      editType: false, //是否可以编辑
      propertyData: {
        materialCode: "", //物资code
        materialGetId: "",
        materialId: "", //物资编码
        materialName: "", //物资名称
        materialType: "",
        receiveAmount: "", //物资已领用数量
        yetReturnNum: "", //物资已归还数量
        returnAmount: "", //物资归还数量
      },
      contentHeight: 0,
      windowH: 0, //获取的浏览器高度
      reason: "", //归还原因
      commonId: "", //新增就是物资id，编辑查看就是物资申请退还Id
      backTime: "", //归还时间
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      sendType: "", //判断是否在抄送列表
      loadingText: "操作中...", //	btn加载状态提示文字
    };
  },

  mounted() {
    if (is_wei()) {
      document.title = "物资归还申请";
    }
    this.editorResize();
    window.addEventListener("resize", this.editorResize);
    window.editPage = this.editPage; //编辑页面
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审核
    this.verifyType = this.$route.query.verifyType;
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.$nextTick(() => {
      this.commonId =
        this.mode == "add"
          ? this.$route.query.backId
          : this.$route.query.commonId; //申请Id
      this.editType = this.mode == "add" ? true : false;
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      this.setShowLoad(false); //加载状态，默认为true加载

      this.getPage();
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    verifyPage() {
      //app调用审批
      this.verifyPageType = true;
    },

    getPage() {
      if (this.mode == "add") {
        this.initPage();
        this.backTime = dateTimeFormat(new Date());
      } else {
        this.materialPage();
      }
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.materialApplyBack
        .detailsmaterialApply(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    materialPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.materialApplyBack
        .detailsmaterialApplyBack(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.reason = res.data.reason;
            _this.backTime = res.data.createTime;

            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    returnAmountChange() {
      if (
        this.propertyData.returnAmount >
        this.propertyData.receiveAmount - this.propertyData.yetReturnNum
      ) {
        this.$toast("归还数量不能大于借出数量");
        this.propertyData.returnAmount =
          this.propertyData.receiveAmount - propertyData.yetReturnNum + "";
      }
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    validate() {
      //校验
      let _this = this;
      if (
        this.reason == "" ||
        this.propertyData.returnAmount == "" ||
        this.propertyData.returnAmount == "0"
      ) {
        _this.$toast("请完善表单信息");
        return false;
      }
      return true;
    },
    checkInput() {
      //确定
      let _this = this;
      let params = "";
      if (this.validate()) {
        let updateData = {
          id: _this.commonId,
          materialGetId: _this.propertyData.materialGetId,
          materialId: _this.propertyData.materialId,
          returnAmount: _this.propertyData.returnAmount,
          yetReturnNum: _this.propertyData.yetReturnNum,
          reason: _this.reason,
        };
        let addData = {
          materialReturnParamList: [
            {
              materialCode: _this.propertyData.materialCode,
              materialGetId: _this.propertyData.materialGetId,
              materialId: _this.propertyData.materialId,
              returnAmount: _this.propertyData.returnAmount,
              yetReturnNum: _this.propertyData.yetReturnNum,
            },
          ],
          reason: _this.reason,
        };
        params = _this.mode == "add" ? addData : updateData;
      
           this.btnLoading = true;
           
        _this.$api.material.materialApplyBack
          .addMaterialApplyBack(_this.mode, params)
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              let text = _this.mode == "add" ? "归还成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            this.btnLoading = false;
          })
          .catch((err) => {
            this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          this.btnLoading = true;
          _this.$api.material.materialApplyBack
            .backBackApply(_this.propertyData.verifyStatus, _this.commonId)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "操作成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
                console.log(res.msg);
              }
              this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },

    editorResize() {
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.contentHeight = clientHeight + 50;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  destroyed() {
    window.removeEventListener("resize", this.editorResize); // 通过有名函数 解除事件订阅
  },
};
</script>
<style lang="less">
.GoodsReturnPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  padding-bottom: 60px;
}
.focusState {
  position: absolute;
}
.baseNone::after {
  content: none;
}
.baseNone {
  .ggInput {
    border-bottom: 1px solid #f6f6f6;
    font-size: 15px;
  }
  .van-field__body {
    .van-field__control {
      text-align: right;
      color: #969799;
    }
  }
}
.baseNone.beizhu {
  min-height: 45px;
}
.btnBox {
  width: 100%;
  padding: 0 14px;
  height: 65px;
  position: fixed;
  left: 0;
  bottom: 0;
  padding-top: 10px;
  z-index: 1009;
  background-color: #fff;
  button {
    width: 100%;
    border-radius: 12px;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    span {
      line-height: 45px;
    }
  }
}

//审批记录样式
.approveList {
  margin-top: 10px;
}
//流程图样式
.flowList {
  margin-top: 10px;
}
</style>